import axios from 'axios'
import { responseHandler, apiErrorHandler } from '../actions/handlers.action'
import { getResources } from '../actions/resources.action'
import get from 'lodash/get'

export const getResourcesData = () => (dispatch, getState) => {
  const state = getState()
  let url = get(state, 'startup.resourcesUrl')
  return axios({
    url: url,
    method: 'GET',
    headers: {
      'Accept-Language': 'en'
    }
  })
    .then(response => {
      responseHandler(dispatch, response, getResources)
      return response
    })
    .catch(function(err) {
      apiErrorHandler(dispatch, err)
    })
}
